"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var validatedViewModel_1 = require("./base/validatedViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        _super.call(this, options);
    }
    ViewModel.prototype.beforeSubmit = function (formElement, extendedData, callback) {
        this.errorMessages([]);
        app.f7.modal({
            text: "Вы точно хотите снять произведение с конкурса?",
            buttons: [{
                    text: "Да",
                    onClick: function () {
                        callback();
                        app.closeModal();
                    }
                },
                {
                    text: "Нет",
                    bold: true
                }]
        });
    };
    ViewModel.prototype.onSubmitSucess = function (result) {
        if (result.data.redirectUrl) {
            this.redirectToPage(result.data.redirectUrl);
        }
    };
    return ViewModel;
}(validatedViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=contestMyWork.js.map